var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#25D366"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.634 19.271c-.195.548-1.133 1.048-1.584 1.116-.404.06-.916.086-1.479-.093-.34-.108-.777-.252-1.337-.495-2.354-1.016-3.892-3.386-4.009-3.543-.117-.156-.958-1.273-.958-2.427 0-1.156.606-1.724.821-1.958a.863.863 0 01.626-.294c.156 0 .313.002.45.008.144.008.337-.054.528.403.195.47.665 1.625.723 1.742.06.118.098.255.02.412-.078.156-.117.254-.235.391-.117.137-.247.306-.352.411-.117.118-.239.244-.103.48.137.234.608 1.003 1.306 1.625.896.8 1.652 1.047 1.887 1.165.235.118.372.098.508-.059.137-.156.587-.685.744-.92.156-.235.312-.196.527-.117.216.078 1.37.646 1.604.763.235.118.391.176.45.274.058.098.058.568-.137 1.116M16.042 8.11c-4.305 0-7.807 3.502-7.809 7.806 0 1.475.412 2.911 1.193 4.154l.186.296-.789 2.88 2.955-.775.285.17a7.79 7.79 0 003.973 1.088h.003c4.303 0 7.805-3.502 7.806-7.807a7.759 7.759 0 00-2.284-5.523 7.757 7.757 0 00-5.519-2.289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.04 25.314h-.004a9.38 9.38 0 01-4.488-1.143l-4.98 1.306 1.333-4.867a9.39 9.39 0 01-1.254-4.695c.003-5.18 4.216-9.392 9.393-9.392a9.33 9.33 0 016.644 2.755 9.335 9.335 0 012.748 6.644c-.002 5.179-4.216 9.392-9.392 9.392m7.886-23.3H8.075a6.059 6.059 0 00-6.06 6.06v15.85a6.059 6.059 0 006.06 6.06h15.85a6.06 6.06 0 006.06-6.06V8.075a6.06 6.06 0 00-6.06-6.06"
  })))));
}

export default SvgIconSnsWhatsApp;